export default class Item {

    static autoIncrementId = 1;

    constructor(data) {
        this.autoId = Item.autoIncrementId++;
        this.data = data;
    }

    get id() {
        return this.autoId;
    }

    get type() {
        return this.data.type;
    }

    get title() {
        return this.data.title;
    }

    get transcript() {
        return this.data.transcript;
    }

    get durationFull() {
        const t = this.data.duration;
        const m = Math.floor(t / 60);
        const s = t - m * 60;
        const minutes = m + (m == 1 ? ' minute' : ' minutes');
        const seconds = s + (s == 1 ? ' second' : ' seconds');

        return m ? minutes + ' ' + seconds : seconds;
    }

    get durationCompact() {
        return this.durationFull.replace(/minute/gi, 'min').replace(/second/gi, 'sec');
    }
}
